import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MainLayout } from "@/components/layout";
import { PageLoader } from "@/components/ui";
import { HomePage } from "@/pages/home-page";
import {
  CreateCharacterPage,
  CreateCartoonPage,
  ExtendCartoonPage,
} from "@/pages/create";
import { GeneratePage } from "@/pages/generate-page";
import { AssetsPage } from "@/pages/assets-page";
import { ExplorePage } from "@/pages/explore-page";
import { FreeGenPage } from "@/pages/free-gen-page";

const BillingPage = lazy(() =>
  import("@/pages/billing-page").then((m) => ({ default: m.BillingPage })),
);
const AffiliatesPage = lazy(() =>
  import("@/pages/affiliates-page").then((m) => ({ default: m.AffiliatesPage })),
);
const SupportPage = lazy(() =>
  import("@/pages/support-page").then((m) => ({ default: m.SupportPage })),
);
const TermsPage = lazy(() =>
  import("@/pages/terms-page").then((m) => ({ default: m.TermsPage })),
);
const PrivacyPage = lazy(() =>
  import("@/pages/privacy-page").then((m) => ({ default: m.PrivacyPage })),
);
const RefundPage = lazy(() =>
  import("@/pages/refund-page").then((m) => ({ default: m.RefundPage })),
);

function AppRoutes() {
  return (
    <MainLayout>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/explore" element={<ExplorePage />} />
          <Route path="/create-character" element={<CreateCharacterPage />} />
          <Route path="/edit-character" element={<Navigate to="/create-character" replace />} />
          <Route path="/create-cartoon" element={<CreateCartoonPage />} />
          <Route path="/free-gen" element={<FreeGenPage />} />
          <Route path="/cartoon-audio" element={<Navigate to="/create-cartoon" replace />} />
          <Route path="/animate-cartoon" element={<Navigate to="/create-cartoon" replace />} />
          <Route path="/extend-cartoon" element={<ExtendCartoonPage />} />
          <Route path="/create" element={<Navigate to="/create-cartoon" replace />} />
          <Route path="/generation/:id" element={<GeneratePage />} />
          <Route path="/assets" element={<AssetsPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/affiliates" element={<AffiliatesPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/refund-policy" element={<RefundPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </MainLayout>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
